// @flow
// React
import React from 'react';
import type {Node} from 'react';

import {Routes as SharedRoutes} from 'components/Routes';
import {JoinModule} from 'modules/join';

const JoinPage = (): Node => (
  <div style={styles.container}>
    <JoinModule />
  </div>
);
const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexGrow: 1,
  },
};

// Mounted under `/join/*` (see PageContainer), so this matches the `:token`
// segment of `/join/:token`.
export const routes = [
  {
    path: ':token',
    Component: JoinPage,
    isProtected: false,
  },
];

// $FlowIgnore
const JoinFrame = () => <SharedRoutes routes={routes} />;

export default JoinFrame;
